/**
 * Author:hong.rong
 * Desc:
 * Date:2022-01-25
 */
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import axios from 'axios'
import { message } from 'antd'
import { COOKIES_MAP, HOME_PATH } from '@/constants'
import { getSystemLocale } from '@/utils'
import { getCookie, clearStorageAll, getStorage, removeCookie } from '@/utils/storage'
import PendingRequest from './pendingRequest'
// @ts-ignore
import { API_HOST } from '../config'

export interface CustomRequestConfig extends AxiosRequestConfig {
  showMessage?: any
  extCancelRequest?: boolean
}

export interface CustomResponse extends AxiosResponse {
  showMessage?: any
  extCancelRequest?: boolean
}

export interface CustomAxiosError extends AxiosError {
  config: CustomRequestConfig
}

axios.defaults.withCredentials = true

const requestHelper = axios.create({
  baseURL: API_HOST,
})

// 实例处理重复pending request工具类
// @ts-ignore
const PR = new PendingRequest(axios)

const redirectUrl = HOME_PATH

const mockBaseUrl = 'http://127.0.0.1:4523/m1/2334415-0-default/'
// 正式环境提交前置为空
const mockUrlList = [
  // 'v4/demand/company/user/corporation/list/leads',
  // 'v4/demand/company/user/corporation/change',
]
requestHelper.interceptors.request.use(
  async (config: CustomRequestConfig) => {
    if (mockUrlList.includes(config.url)) {
      config.baseURL = mockBaseUrl
    }
    // @ts-ignore
    const lang = getSystemLocale()
    if (lang) {
      config.headers['X-CB-Locale'] = lang
      // config.headers['Accept-Language'] = lang;
    }
    const token = getCookie(COOKIES_MAP.TOKEN)
    if (token) {
      config.headers.accessToken = token
    }
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    try {
      if (window.SinoCommonClient) {
        // appid
        config.headers['X-Sino-Global-App-Id'] = window.SinoCommonClient.getAppId();
        // 指纹
        config.headers.Device = await window.SinoCommonClient.sdk.getFpDeviceToken()
      }
    } catch (e) {
      // 吞掉指纹获取失败的错误
    }
    if (config.extCancelRequest) {
      // 检查是否存在重复请求，若存在则取消已发的请求
      PR.removePendingRequest(config)
      // 把当前请求添加到pendingRequest对象中
      PR.addPendingRequest(config)
    }
    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  },
)

requestHelper.interceptors.response.use(
  (response: CustomResponse) => {
    const { extCancelRequest, config = {}, data = {} } = response as any
    const code = data.code
    // 从pendingRequest对象中移除请求
    if (extCancelRequest) {
      PR.removePendingRequest(config)
    }

    // token失效
    if (code === 401) {
      clearStorageAll()
      window?.gio?.('clearUserId')
      window?.DATAFLUX_RUM?.removeUser()
      removeCookie()
      // eslint-disable-next-line no-underscore-dangle
      window.location.href = redirectUrl
    }

    // 101060008(老)、203030008(新): 分享的链接已过期 210021003: 不能转存自己分享的作品
    // 102100002: ve、可画模板失效；104010002: ve草稿失效；102100029: 可画草稿失效 210011023: 分发作品时bc账户不可用 210191005:主体找不到关联关系
    // 995 ai 模特换脸
    if (
      ![
        0, 401, 996, 999, 104010002, 102100029, 102100002, 210011023, 101060008, 203030008,
        210191005, 210011022, 995,
      ].includes(code)
    ) {
      message.destroy()
      data?.message && message.error(data.message)
      return Promise.resolve(data)
    }
    return response
  },
  (error: CustomAxiosError) => {
    if (error?.config && error?.config?.extCancelRequest) {
      // 从pendingRequest对象中移除请求
      PR.removePendingRequest(error.config || {})
    }
    if (error?.response) {
      switch (error.response.status) {
        case 401: // token失效
          // 如果是内部用户，跳转sso链接, 如果是外部用户，跳转登录页
          clearStorageAll()
          window.location.href = redirectUrl
          break
        default:
          break
      }
    }
    return Promise.reject(error.response)
  },
)
export default requestHelper
